type StopDictationFn = () => void;

let activeStop: StopDictationFn | null = null;

/**
 * Registry for the active dictation stop, so a route change can release the mic even if the chat
 * input unmounted first.
 */
export function registerActiveDictationStop(stop: StopDictationFn): () => void {
  activeStop = stop;
  return () => {
    if (activeStop !== stop) return;
    activeStop = null;
    // Clear the slot before stopping, so nothing calls a stale callback.
    try {
      stop();
    } catch {
      // ignore — dictation teardown should never block unmount
    }
  };
}

export function stopActiveDictationSession(): void {
  activeStop?.();
}
